<div class="cx-review">
  <div class="cx-review-summary row">
    @if ((steps$ | async).slice(0, -1); as steps) {
      <div class="col-md-12 cx-review-shipping-col">
        @for (step of shippingSteps(steps); track step) {
          @switch (step.type[0]) {
            @case (checkoutStepTypeShippingAddress) {
              <ng-container *ngTemplateOutlet="shippingAddress"></ng-container>
            }
            @case (customCheckoutStepTypeDeliveryMode) {
              <ng-container *ngTemplateOutlet="deliveryMode"></ng-container>
            }
          }
        }
      </div>
      <div class="col-md-12 cx-review-payment-col">
        @for (step of customPaymentSteps(steps); track step) {
          @switch (step.type[0]) {
            @case (customCheckoutStepTypePaymentDetails) {
              <ng-container *ngTemplateOutlet="paymentMethod"></ng-container>
            }
          }
        }
      </div>
    }
  </div>


  <!-- SHIPPING ADDRESS SECTION -->
  <ng-template #shippingAddress>
    @if (deliveryAddress$ | async; as deliveryAddress) {
      @if (deliveryAddress.firstName != undefined) {
        <div class="cx-review-summary-card cx-review-card-address">
          <div class="title">
            {{"addressCard.shipTo" | cxTranslate}}
          </div>
          <cx-card [content]="
          getShippingAddressCard(deliveryAddress, countryName$ | async) | async
        "></cx-card>
          <div class="cx-review-summary-edit-step">
            <a [routerLink]="
            {
              cxRoute: getCheckoutStepUrl(checkoutStepTypeShippingAddress)
            } | cxUrl
          ">{{
              'addressCard.edit' | cxTranslate
            }}</a>
          </div>
        </div>
      }
    }
  </ng-template>

  <!-- DELIVERY MODE SECTION -->
  <ng-template #deliveryMode>
    <div class="cx-review-summary-card cx-review-card-shipping">
      @if (deliveryMode$ | async; as deliveryMode) {
        <cx-card
        [content]="getDeliveryModeCard(deliveryMode) | async"></cx-card>
      }
      <div class="cx-review-summary-edit-step">
        <a [routerLink]="
            { cxRoute: getCheckoutStepUrl(customCheckoutStepTypeDeliveryMode) }
              | cxUrl
          ">
          {{
          'addressCard.edit' | cxTranslate
          }}
        </a>
      </div>
    </div>
  </ng-template>

  <!-- PAYMENT METHOD SECTION -->
  <ng-template #paymentMethod>
    @if (cart$ | async; as cart) {
      @if (cart.paymentAddress) {
        <div class="cx-review-summary-card cx-review-card-payment">
          <div class="title">
            {{"addressCard.billTo" | cxTranslate}}
          </div>
          <div>
            <cx-card [content]="getPaymentMethodCard(cart.paymentAddress) | async"></cx-card>
          </div>
          <div class="cx-review-summary-edit-step">
            <a [routerLink]="
            { cxRoute: getCheckoutStepUrl(checkoutStepTypePaymentDetails) }
              | cxUrl
          ">
              {{
              'addressCard.edit' | cxTranslate
              }}
            </a>
          </div>
        </div>
      }
    }
  </ng-template>
</div>
